import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Moneybar } from '@shared/funding/moneybar';

@Component({
  selector: 'app-moneybar',
  templateUrl: 'moneybar.component.html',
  styleUrls: ['moneybar.component.scss'],
  standalone: false,
})
export class MoneybarComponent {
  // Width of the "normal" moneybar without buffer in percentage
  private static readonly MONEYBAR_WIDTH = 95;

  @Input() label!: string;
  @Input() moneybarData!: Moneybar;

  constructor(private currencyPipe: CurrencyPipe) {}

  donatedWidth(): number {
    return (100 * this.moneybarData.donated) / this.moneybarData.goal;
  }
  donatedDisplayValue(): string {
    return this.currencyPipe.transform(this.moneybarData.donated, 'EUR') || '0';
  }
  discountedWidth(): number {
    return (100 * this.moneybarData.presentValueOfFuturePayments) / this.moneybarData.goal;
  }
  discountedDisplayValue(): string {
    return this.currencyPipe.transform(this.moneybarData.presentValueOfFuturePayments, 'EUR') || '0';
  }
  get shortOfGoal(): number {
    return this.moneybarData.goal - this.moneybarData.donated - this.moneybarData.presentValueOfFuturePayments;
  }
  shortOfGoalWidth(): number {
    return (100 * this.shortOfGoal) / this.moneybarData.goal;
  }
  shortOfGoalDisplayValue(): string {
    return this.currencyPipe.transform(this.shortOfGoal, 'EUR') || '0';
  }
  goalDisplayValue(): string {
    return this.currencyPipe.transform(this.moneybarData.goal, 'EUR') || '0';
  }
  bufferWidth(): number {
    return (
      ((MoneybarComponent.MONEYBAR_WIDTH / (100 - MoneybarComponent.MONEYBAR_WIDTH)) * 100 * this.moneybarData.buffer) /
      this.moneybarData.goal
    );
  }
  bufferValue(): string {
    return this.currencyPipe.transform(this.moneybarData.buffer, 'EUR') || '0';
  }

  overshootWidth(): number {
    const overshootValue =
      this.moneybarData.donated + this.moneybarData.presentValueOfFuturePayments - this.moneybarData.goal;

    return overshootValue < 0
      ? 0
      : ((MoneybarComponent.MONEYBAR_WIDTH / (100 - MoneybarComponent.MONEYBAR_WIDTH)) * 100 * overshootValue) /
          this.moneybarData.goal;
  }
}
